import RouteWithSubRoutes, { BaseRoute } from 'component/RouteWithSubRoutes';
import { getCompanyId, getUserId, getOrgCode } from 'data/storage';
import { getUserInfo, getSSOUserInfo } from 'model/user';
import { getOrderSettings } from 'model/meeting';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import Navigation from './component/Navigation';
import styles from './index.module.scss';
import { isSSO } from 'util/crossenv';
import { RootState } from 'model';
import Grayscale from 'lib/grayscalePublishing';

interface IProps {
  routes: BaseRoute[];
}
// 容器组件
const Home: React.FunctionComponent<IProps> = ({ routes }) => {
  const beEmbedded = useSelector((state: RootState) => state.app.beEmbedded);
  const dispatch = useDispatch();

  useEffect(() => {
    const userId = getUserId();
    const companyId = getCompanyId();
    const orgCode = getOrgCode();

    if (!userId) return;
    if (isSSO()) {
      dispatch(getSSOUserInfo({ userId, companyId }));
    } else {
      dispatch(getUserInfo(userId));
    }
    /** 获取会议配置 */
    if (companyId) {
      dispatch(getOrderSettings());
    }
    /** 灰发逻辑，如果本地有 orgCode，则设置 cookie 的 orgCode 参数 */
    if (orgCode) {
      Grayscale.set(orgCode);
      Grayscale.checkUpdate();
    }
  }, []);

  useEffect(() => {
    // 嵌入第三方应用时，设置为纯白背景色
    if (beEmbedded && document) {
      document.body.style.backgroundColor = '#ffffff';
    }
  }, [beEmbedded]);

  return (
    <div className={beEmbedded ? styles.beEmbeddedWrap : styles.warp}>
      <Navigation />
      <div className={styles.container}>
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
        </Switch>
      </div>
    </div>
  );
};

export default Home;
